import React, { useEffect } from 'react';
import { googleMapsEnhance } from 'modules/google-maps/utils';
import { GoogleMap } from 'react-google-maps';

const DriversMap = ({ onMount, mapRef, children, ...props }) => {
  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <GoogleMap ref={mapRef} {...props}>
      {children}
    </GoogleMap>
  );
};

export default googleMapsEnhance(DriversMap);
